<template>
  <div class="filter-wrapper">
    <!-- Filter Button -->
    <button class="filter-icon-button" @click="showModal">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <path d="M7 14H21M3.5 7H24.5M10.5 21H17.5" stroke="var(--primary-color)" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>

    <!-- Modal -->
    <div v-if="showFilterModal" class="filter-modal">
      <div class="modal-header">
        <span class="modal-title">{{ $t('filters.apply_filter') }}</span>
        <span class="close-icon" @click="showFilterModal = false">{{ $t('modals.close') }}</span>
      </div>
      <div class="filter-field">
        <label>{{ $t('filters.primary_classification') }}</label>
        <div class="custom-select" @click="toggleDropdown('category')">
          <span>{{ selectedCategory?.category_name || $t('filters.select_primary_classification') }}</span>
          <img src="/arrowDownNew.png" alt="" />
          <ul v-if="dropdownOpen === 'category'" class="dropdown-options">
            <li v-for="cat in categories" :key="cat.id" @click.stop="selectOption('category', cat)">
              {{ cat.category_name }}
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-actions">
        <button class="cancel-btn" @click="showFilterModal = false">{{ $t('filters.cancel') }}</button>
        <button class="apply-btn" @click="applyFilter">{{ $t('filters.apply_filter') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from '@/utils/api'

export default {
  name: 'Filter',
  props: {
    tenantId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      categories: [],
      departments: [],
      showFilterModal: false,
      selectedCategory: null,
      selectedDepartment: null,
      selectedActive: '',
      dropdownOpen: null,
      appliedFilters: {
        categoryId: '',
        departmentId: '',
        is_active: '',
      },
    }
  },
  methods: {
    async fetchCategories() {
      try {
        const response = await get('/v1/categories')
        if (response?.data?.code === 200) {
          this.categories = response.data.data.data
        }
      } catch (err) {}
    },

    async fetchTenantCategories() {
      try {
        const response = await get(`/v1/tenant-categories?tenantId=${this.tenantId}&page=1&pageSize=100000&isActive=true`)
        if (response?.data?.code === 200) {
          this.categories = (response.data.data.data || []).map((category) => ({
            id: category.category_id,
            category_name: category.category_display_name,
          }))
        }
      } catch (err) {}
    },

    async fetchDepartmentsByCategory(categoryId) {
      try {
        const url = `/v1/departments?categoryId=${categoryId}&page=1&pageSize=100000`
        const response = await get(url)
        if (response?.data?.code === 200) {
          this.departments = response.data.data.data || []
        }
      } catch (err) {
        this.departments = []
      }
    },

    async fetchTenantDepartments(categoryId) {
      try {
        const url = `/v1/tenant-departments?tenantId=${this.tenantId}&categoryId=${categoryId}&page=1&pageSize=100000`
        const response = await get(url)
        if (response?.data?.code === 200) {
          this.departments = (response.data.data.data || []).map((dept) => ({
            id: dept.department_id,
            department_name: dept.department_display_name,
          }))
        }
      } catch (err) {
        this.departments = []
      }
    },

    async selectOption(type, value) {
      switch (type) {
        case 'category':
          this.selectedCategory = value
          // if (value) {
          //   if (this.tenantId) {
          //     await this.fetchTenantDepartments(value.id)
          //   } else {
          //     await this.fetchDepartmentsByCategory(value.id)
          //   }
          // }
          break
        case 'department':
          this.selectedDepartment = value
          break
        case 'active':
          this.selectedActive = value
          break
      }
      this.dropdownOpen = null
    },

    toggleDropdown(type) {
      if (type === 'department' && !this.selectedCategory) {
        return
      }
      this.dropdownOpen = this.dropdownOpen === type ? null : type
    },

    async showModal() {
      this.showFilterModal = true
      if (this.tenantId != 'master') {
        await this.fetchTenantCategories()
      } else {
        await this.fetchCategories()
      }
    },

    applyFilter() {
      const filters = {}

      if (this.selectedCategory) {
        filters.categoryId = this.selectedCategory.id
      }

      if (this.selectedDepartment) {
        filters.departmentId = this.selectedDepartment.id
      }

      if (this.selectedActive !== '') {
        filters.is_active = this.selectedActive
      }

      this.appliedFilters = { ...filters }
      this.showFilterModal = false
      this.$emit('filter-applied', filters)
    },

    resetFilters() {
      // Don't emit event during initialization
      const shouldEmit = this.selectedCategory !== null || this.selectedDepartment !== null

      this.selectedCategory = null
      this.selectedDepartment = null
      this.selectedActive = ''
      this.departments = []
      this.appliedFilters = {
        categoryId: '',
        departmentId: '',
      }

      // Only emit if there were actual filters to reset
      if (shouldEmit) {
        this.$emit('filter-applied', {})
      }
      this.showFilterModal = false
    },
  },

  watch: {
    tenantId: {
      immediate: true,
      handler(newVal, oldVal) {
        // Only reset and refetch if tenantId actually changed (not initial load)
        if (oldVal !== undefined) {
          this.resetFilters()

          // Only fetch categories if modal is open
          if (this.showFilterModal) {
            if (newVal != 'master') {
              this.fetchTenantCategories()
            } else {
              this.fetchCategories()
            }
          }
        }
      },
    },
  },
}
</script>

<style scoped>
.filter-wrapper {
  position: relative;
}

.filter-icon-button {
  width: 28px;
  height: 28px;
  border: none;
  background: transparent;
  cursor: pointer;
}

.filter-modal {
  position: absolute;
  right: 0;
  top: 40px;
  width: 503px;
  max-width: 95vw;
  background: white;
  border-radius: 12px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  padding: 24px;
  font-family: 'Archivo', sans-serif;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 11px;
  border-bottom: 1px solid #e8e8e8;
}

.modal-title {
  font-size: 24px;
  font-weight: 500;
  color: var(--primary-color);
  line-height: 18px;
  letter-spacing: 0.24px;
}

.close-icon {
  font-size: 24px;
  cursor: pointer;
}

.filter-field {
  margin-top: 22px;
}
.filter-field label {
  font-size: 18px;
  font-weight: 500;
  color: #32393e;
  margin-bottom: 6px;
  display: block;
}

.custom-select {
  position: relative;
  width: 455px;
  height: 41px;
  border: 1px solid #d1d1d1;
  border-radius: 6px;
  background: #fff;
  padding: 10px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.custom-select img {
  width: 14px;
  height: 14px;
}

.dropdown-options {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: white;
  border: 1px solid #d1d1d1;
  border-radius: 6px;
  margin-top: 4px;
  z-index: 10;
  list-style: none;
  padding: 4px 0;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
}

.dropdown-options li {
  padding: 10px 12px;
  font-size: 14px;
  color: #32393e;
  cursor: pointer;
}

.dropdown-options li:hover {
  background: #f5f5f5;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 28px;
}

.cancel-btn {
  padding: 8px 20px;
  border: 1px solid var(--primary-color);
  background: transparent;
  color: var(--primary-color);
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}

.apply-btn {
  padding: 8px 20px;
  background: var(--primary-color);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}
.customHR {
  width: 100%;
  height: 2px;
  background-color: #e8e8e8;
}

.custom-select.disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}
</style>
